export enum InterDeviceAssociationType {
  BLUETOOTH_SCANNER_ASSIGNMENT = 'BLUETOOTH_SCANNER_ASSIGNMENT'
}
